/**
 * NearestRelativeSection - Nearest relative contact and address
 */

import { OathInput, OathSelect } from '../../../../shared/OathUI';
import { ACCEPT_QUOTE_FIELD_MAX_LENGTH } from '../../shared/requestFieldLimits';
import { STATE_OPTIONS } from '../../shared/usStates';

const NearestRelativeSection = ({ formState, dispatch, requiredFields }) => {
  const isRequired = (field) => requiredFields.includes(field);
  const set = (field) => (val) => dispatch({ type: 'SET_FIELD', field, value: val });

  return (
    <div>
      <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-3">Nearest Relative</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="sm:col-span-2">
          <OathInput
            label="Name"
            maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nearestRelativeName}
            value={formState.nearestRelativeName}
            onChange={set('nearestRelativeName')}
            placeholder="Full name"
            required={isRequired('nearestRelativeName')}
          />
        </div>
        <div className="sm:col-span-2">
          <OathInput
            label="Street"
            maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nearestRelativeAddressStreet1}
            value={formState.nearestRelativeAddressStreet1}
            onChange={set('nearestRelativeAddressStreet1')}
            placeholder="Street address"
            required={isRequired('nearestRelativeAddressStreet1')}
          />
        </div>
        <div className="sm:col-span-2">
          <OathInput
            label="Street 2"
            maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nearestRelativeAddressStreet2}
            value={formState.nearestRelativeAddressStreet2}
            onChange={set('nearestRelativeAddressStreet2')}
            placeholder="Apt, suite, etc."
          />
        </div>
        <OathInput
          label="City"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nearestRelativeAddressCity}
          value={formState.nearestRelativeAddressCity}
          onChange={set('nearestRelativeAddressCity')}
          placeholder="City"
          required={isRequired('nearestRelativeAddressCity')}
        />
        <OathSelect
          label="State"
          value={formState.nearestRelativeAddressState}
          onChange={set('nearestRelativeAddressState')}
          options={STATE_OPTIONS}
          placeholder="Select state..."
          required={isRequired('nearestRelativeAddressState')}
        />
        <OathInput
          label="Zip Code"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nearestRelativeAddressZipCode}
          value={formState.nearestRelativeAddressZipCode}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'nearestRelativeAddressZipCode', value: val.replace(/\D/g, '').slice(0, 5) })}
          placeholder="12345"
          required={isRequired('nearestRelativeAddressZipCode')}
        />
      </div>
    </div>
  );
};

export default NearestRelativeSection;
